import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Switch, Popover } from 'antd';
import EntityBusinessCaseDropDown from '../../components/EntityBusinessCaseDropDown';
import EntityBusinessCase from '../../components/EntityBusinessCase';
import { periodsActions, businessActions, allocationActions } from '../../redux/actions';
import { useMemo } from 'react';

import './styles.scss';

const EntityBusinessCases = ({ entity, setHighlightedScenarios, showHeader = true }) => {
    const dispatch = useDispatch();
    const accountStructure = useSelector((state) => state.accounts.accountStructure);
    const expandedPeriods = useSelector((state) => state.periods.expandedPeriods);
    const periods = useSelector((state) => state.periods.periods);
    const assembledBusinessCase = useSelector((state) => state.business.assembledBusinessCase);
    const businessCases = useSelector((state) => state.business.businessCases);
    const allocations = useSelector((state) => state.allocations.allocations);

    const assemblingCase = useSelector((state) => state.business.assemblingCase);
    const fetchingExpandedPeriods = useSelector((state) => state.periods.fetchingExpandedPeriods);

    const [currentBusinessCaseName, setCurrentBusinessCaseName] = useState('Select business case');
    const [selectedBusinessCase, setSelectedBusinessCase] = useState(null);
    const [selectedBusinessCaseId, setSelectedBusinessCaseId] = useState(null);
    const [previewOn, setPreviewOn] = useState(false);

    useEffect(() => {
        dispatch(businessActions.getBusinessCases());
        dispatch(allocationActions.getAllocations());
    }, [dispatch]);

    useEffect(() => {
        if (periods != null && expandedPeriods == null) {
            if (!fetchingExpandedPeriods) dispatch(periodsActions.getExpandedPeriods());
        }
    }, [dispatch, periods, fetchingExpandedPeriods, expandedPeriods]);

    const handleSetCurrentBusinessCaseName = (name) => {
        setCurrentBusinessCaseName(name);
    };

    const handleSelectBusinessCase = (businessCaseId) => {
        if (assemblingCase) return;
        const bc = businessCases?.find(b => b.business_case_id === businessCaseId) || null;
        setSelectedBusinessCase(bc);
        setSelectedBusinessCaseId(businessCaseId);
        setPreviewOn(false);               // start from baseline
        setCurrentBusinessCaseName(bc ? bc.name : 'Select business case');
        dispatch(businessActions.assembleBusinessCase(businessCaseId, []));
    
};

const bcAllocations = useMemo(() => {
      if (!selectedBusinessCase || !Array.isArray(allocations)) return [];
      const bcId = String(selectedBusinessCase.business_case_id);
    
      // be tolerant to either camelCase or snake_case coming from API
        return allocations.filter(a => {
            const aBcId = a.businessCaseId ?? a.business_case_id;
            return String(aBcId) === bcId;
        });
    }, [allocations, selectedBusinessCase]);

const hasBcAllocations = bcAllocations.length > 0;

const handleTogglePreview = (checked) => {
  if (!selectedBusinessCase) return;

  dispatch(
    businessActions.assembleBusinessCase(
        selectedBusinessCase.business_case_id,
        checked ? bcAllocations : []         // with vs without allocations
    )
  );

  setPreviewOn(checked);
};

    return (
        <div
            style={{
                background: '#f1f1f1',
                width: '100%',
                height: '100%',
                padding: '1rem',
            }}
            className="site-card-wrapper"
        >
            {
            showHeader && (
            <Row gutter={[16, 16]} style={{ marginBottom: 25 }} align="middle" justify="space-between">
                  {/* dropdown + preview switch */}
       
     

            <Col>
                <EntityBusinessCaseDropDown
                    handleSelectBusinessCase={handleSelectBusinessCase}
                    currentBusinessCaseName={currentBusinessCaseName}
                    handleSetCurrentBusinessCaseName={handleSetCurrentBusinessCaseName}
                    entity={entity}
                    setHighlightedScenarios={setHighlightedScenarios}
                />
            </Col>
            
            <Col>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span>Preview</span>
                <span style={{ fontSize: 12, opacity: 0.7 }}>
                {previewOn ? 'With allocations' : 'Without allocations'}
                </span>
                
                <Switch
                checked={previewOn}
                onChange={handleTogglePreview}
                disabled={!selectedBusinessCase || !hasBcAllocations}
                />

        {selectedBusinessCase && (
        <Popover
            placement="bottomRight"
            title="Scenarios in this Business Case"
            content={
            <div style={{ maxHeight: 260, overflow: 'auto' }}>
                {(selectedBusinessCase.business_scenario || []).map(s => (
                <div key={s.scenario_id}>• {s.name}</div>
                ))}
            </div>
            }
        >
            <a>{(selectedBusinessCase.business_scenario || []).length} scenarios</a>
        </Popover>
        )}
            </div>
        </Col>
            </Row>
            )}



            {!assemblingCase && assembledBusinessCase ? (
                <EntityBusinessCase
                    accountStructure={accountStructure}
                    periods={periods}
                    expandedPeriods={expandedPeriods}
                    assemblingCase={assemblingCase}
                    assembledBusinessCase={assembledBusinessCase}
                />
            ) : null}
        </div>
    );
};
export default EntityBusinessCases;
